export default {
      id: "straighten-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#straighten",
      toString: function () {
        return this.url;
      }
    }